import axios from "axios";
import TokenService from "./token.service";

const MAINTENANCE_MESSAGE =
  "The system is currently under maintenance. Please try again later.";

const isServerUnavailable = (err) => {
  if (!err.response) {
    return (
      err.code === "ERR_NETWORK" ||
      err.code === "ECONNABORTED" ||
      err.message === "Network Error"
    );
  }

  const status = err.response.status;
  return status === 502 || status === 503 || status === 504;
};

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  // baseURL: "https://mt5-data-test.herokuapp.com/api",
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      // config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
      config.headers["x-access-token"] = token; // for Node.js Express back-end
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    if (res && res.data && res.data.result) {
      return res.data.result;
    }
    return res;
  },
  async (err) => {
    console.error('Axios Response Error:', err);
    if (isServerUnavailable(err)) {
      err.message = MAINTENANCE_MESSAGE;
    } else if (err.response?.data?.message) {
      err.message = err.response.data.message;
    } else if (err.response?.data?.error) {
      err.message = err.response.data.error;
    }

    return Promise.reject(err);
  }
);

export default instance;
